import { ActionPlanShell } from '@/modules/actionPlan/pages/components/ActionPlanShell'

export function Component() {
  return <ActionPlanShell />
}

Component.displayName = 'ActionPlan'
